<template>
  <van-popup style="width: 80%" round  v-model="show">
    <div class="content">
      <h3 class="title">拒绝退款</h3>
      <div class="text">
        余额不足退款，请稍后重试，或进行线下退款，退款后请上传“线下退款凭证”
      </div>
      <div class="btn-box">
        <div class="btn-item secondary" @click="close">取消</div>
        <div class="btn-item" @click="consent">上传退款凭证</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    showofflineRefundPop: {
      type: Boolean,
      default: false
    },
    orderNo: {
      type: String,
      default: ''
    }
  },
  computed: {
    show: {
      get() {
        return this.showofflineRefundPop
      },
      set(newVal) {
        this.$emit('update:showofflineRefundPop',newVal)
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.show = false
    },
    consent() {
      this.$router.push({
        path: "/refund-voucher",
        query: { orderNo: this.orderNo, number: -1 }
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
  .content {
    padding: 10px 20px;
    .title {
      color: #333333;
      margin: 10px 0 0 0px;
      text-align: center;
    }
   
    .btn-box {
      display: flex;
      justify-content: space-between;
      .btn-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 36px;
        color: #FFFFFF;
        font-size: 17px;
        background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%);
        border-radius: 4px;
        margin: 10px 10px;
      }
      .secondary {
        color: #333;
        background: #E5E5E5;
      }
    }
    .text {
      color: #333333;
      font-size: 15px;
      line-height: 26px;
      margin: 20px 0;
    }
  }
</style>